<template>
  <div class="col-md-6 col-sm-6 col-xs-6 q-pl-sm">
    <div class="row col-12 items-center justify-between q-mb-md">
      <span class="text-h6 text-brand-5">Selecione a Ferramenta</span>
      <q-input
        class="q-pl-md"
        rounded
        outlined
        dense
        debounce="300"
        v-model="filter"
        placeholder="Pesquisar"
      >
        <template v-slot:append>
          <q-icon name="search"></q-icon>
        </template>
      </q-input>
    </div>
    <div class="row col-12 justify-end">
      <q-btn
        class="respI"
        no-caps
        color="positive"
        icon="check_circle_outline"
        label="Selecionar Todos"
        @click="selecionarTodos"
      />
      <q-btn
        class="respI q-ml-md"
        no-caps
        color="red"
        icon="highlight_off"
        label="Desselecionar Todos"
        @click="desselecionarTodos"
      />
    </div>
    <q-table
      flat
      table-header-class="bg-accent text-width-bold"
      class="q-mt-sm tabela-tamanho-fixo"
      hide-pagination
      style="height: 500px"
      dense
      :rows="listaFerramentas"
      :columns="columns"
      :loading="disable"
      :rows-per-page-options="[0]"
      hide-bottom
      no-data-label
      @request="handleRequest"
    >
      <template v-slot:header="props">
        <q-tr :props="props">
          <q-th v-for="col in props.cols" :key="col.name" :props="props">
            {{ col.label }}
          </q-th>
        </q-tr>
      </template>
      <template #body-cell-selecione="props">
        <q-td>
          <q-checkbox v-model="selecionados" :val="props.row" />
        </q-td>
      </template>
    </q-table>
    <div class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
  </div>
</template>

<script>
import { ref, watch, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  props: ["atualizar"],
  setup(props, { emit }) {
    const store = useStore();
    const router = useRouter();
    const unidade = ref({
      id: "",
      nome: "",
    });
    const filter = ref("");
    const disable = ref(true);
    const selecionados = ref([]);
    const listaUnidades = ref([]);
    const listaFerramentas = ref([]);
    const selecionaImagem = ref(false);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 100,
      rowsNumber: 100,
    });

    const columns = [
      {
        name: "selecione",
        label: "Selecionar",
        field: "selecione",
        align: "left",
      },
      {
        name: "nome",
        label: "Nome da Ferramenta",
        field: "nome",
        align: "left",
      },
      {
        name: "descricao",
        label: "Descrição",
        field: "descricao",
        align: "left",
      },

      {
        name: "patrimonio",
        label: "Patrimonio",
        field: (row) => row.patrimonio,
        align: "left",
      },
      {
        name: "status",
        label: "Status Atual",
        field: "status",
        align: "left",
        sortable: true,
      },
    ];

    let listarFerramentas = async (page = 0, rowsPerPage = 100) => {
      if (props.atualizar == "" || props.atualizar == undefined) {
        listaFerramentas.value = [];
        return;
      }
      disable.value = true;
      try {
        let resposta = await store.dispatch("fer/listarFerramentas", {
          unidadeId: store.state.org.unidadeData.id,
          perPage: rowsPerPage,
          page: page,
          filtro: filter.value,
        });

        listaFerramentas.value = resposta.resposta.data.result.data;

        disable.value = false;
      } catch (error) {
        console.error(error);
      }
    };

    const selecionarTodos = async () => {
      listaFerramentas.value.forEach((e) => {
        selecionados.value.push(e);
      });
      emit("ferramentasSelecionadas", selecionados.value);
    };

    const desselecionarTodos = async () => {
      selecionados.value = [];
    };

    watch(
      () => selecionados.value,
      () => {
        emit("ferramentasSelecionadas", selecionados.value);
      }
    );

    watch(
      () => filter.value,
      () => {
        listarFerramentas();
      }
    );

    watch(
      () => props.atualizar,
      () => {
        listarFerramentas();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        listarFerramentas();
      }
    );

    const handleRequest = async () => {
      listarFerramentas(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        handleRequest();
      }
    );

    const detalhes = async (value) => {
      router.push({
        name: "movimentarStatusFerramentaDetalhes",
        params: { id: value },
      });
    };

    return {
      unidade,
      selecionaImagem,
      listaFerramentas,
      listaUnidades,
      columns,
      selecionados,
      disable,
      filter,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      selecionarTodos,
      desselecionarTodos,
      pagination,
      detalhes,
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
}
</style>
